import React, { useContext } from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    EditButton,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    PasswordInput,
    required,
} from "react-admin";
import { AuthContext } from "../../context/AuthContext";

export const UserList = () => {
    const { role } = useContext(AuthContext);

    return (
        <List>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="username" label="Логин" />
                <TextField source="email" label="Email" />

                {role === "admin" && (
                    <BooleanField source="is_staff" label="Админ" />
                )}

                <BooleanField source="is_active" label="Активен" />

                {role === "admin" && (
                    <TextField source="role" label="Роль" />
                )}

                <EditButton />
            </Datagrid>
        </List>
    );
};

export const UserCreate = () => {
    const { role } = useContext(AuthContext);

    return (
        <Create>
            <SimpleForm>
                <TextInput source="username" label="Логин" validate={[required()]} />
                <TextInput source="email" label="Email" />
                <PasswordInput source="password" label="Пароль" validate={[required()]} />

                {role === "admin" && (
                    <BooleanInput source="is_staff" label="Администратор" />
                )}

                <BooleanInput source="is_active" label="Активен" defaultValue={true} />
            </SimpleForm>
        </Create>
    );
};

export const UserEdit = () => {
    const { role } = useContext(AuthContext);

    return (
        <Edit>
            <SimpleForm>
                <TextInput source="username" label="Логин" validate={[required()]} />
                <TextInput source="email" label="Email" />
                <PasswordInput source="password" label="Новый пароль" />

                {role === "admin" && (
                    <BooleanInput source="is_staff" label="Администратор" />
                )}

                <BooleanInput source="is_active" label="Активен" />
            </SimpleForm>
        </Edit>
    );
};